import Breadcrumb from 'components/Common/Breadcrumb2';
import { convertToDateOnly, formatDateTimeToAmPm } from 'helpers/dateFormat_helper';
import Cookies from 'js-cookie';
import axiosInstance from 'pages/Utility/axiosInstance';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams, } from 'react-router-dom';
import { FadeLoader } from 'react-spinners';
import { Container, Row, Col, Card, CardBody, Button, Table, ListGroup, ListGroupItem, Modal, FormGroup, ModalHeader, ModalFooter, ModalBody, Label, Input } from 'reactstrap';
import InsertExtensionModal from './insertExtend';
import { showSuccess } from 'helpers/notification_helper';
import { FaCodeBranch, FaHashtag, FaUser, FaUserCircle } from 'react-icons/fa';
import { SlCalender } from "react-icons/sl";
import { RiTeamLine } from "react-icons/ri";
import { IoCopyOutline } from "react-icons/io5";
import LOGO_IMG from '../../assets/images/logo-dark.png'
import * as Yup from 'yup';
import Select from 'react-select';
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import { LiaComment } from 'react-icons/lia';
import { LuSquareUserRound } from "react-icons/lu";
import { AiOutlineSolution } from "react-icons/ai";

const SiteSurveyDetails = () => {

  const [SiteSurveyDetails, setSiteSurveyDetails] = useState();
  const [addresses, setAddresses] = useState();
  const [customerProfile, setCustomerProfile] = useState();
  const [SiteSurveyItems, setSiteSurveyItems] = useState();
  const [isExtend, setIsExtend] = useState(false);
  const [isCancellation, setIsCancellation] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [images, setImages] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [statusList, setStatusList] = useState();
  const [selectedStatus, setSelectedStatus] = useState();
  const [submittedStatus, setSubmittedStatus] = useState();
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [showStartModal, setShowStartModal] = useState(false);
  const [reason, setReason] = useState();
  const [showPendingConfirmationModal, setShowPendingConfirmationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams()
  const navigate = useNavigate();
  const printRef = useRef();
  const [confirmation, setConfirmation] = useState(false);

  const permissions2 = JSON.parse(localStorage?.getItem('permissions'));
  const user = JSON.parse(Cookies.get('authUser'));

  if (!permissions2?.map(item => item?.permissionName)?.includes("Site Survey Details") && !permissions2?.map(item => item?.permissionName)?.includes("Add SiteSurvey") && !permissions2?.map(item => item?.permissionName)?.includes("Edit SiteSurvey") && !permissions2?.map(item => item?.permissionName)?.includes("Site Survey Extension") && !permissions2?.map(item => item?.permissionName)?.includes("Site Survey Cancellation") && !permissions2?.map(item => item?.permissionName)?.includes("Site Survey Extension")) {
    navigate('/pages-403')
  }

  const userId = JSON.parse(Cookies.get('authUser'))?.userId

  const fetchSiteSurveyDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('', { params: { sp: "usp_GetSiteSurveyProfile", SiteSurveyId: id } })
      setSiteSurveyDetails(response?.data?.Data?.[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const fetchStatusList = async () => {
    try {
      const response = await axiosInstance.get('', { params: { sp: "usp_GetSiteSurveyStatus", sitesurveyId: id, userId: userId } })
      if (response) {
        setStatusList(response?.data?.Data)
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (loading) return;
    fetchSiteSurveyDetails()
    if (user?.userRole !== "Sales agent") {
      fetchStatusList();
    }
  }, []);

  useEffect(() => {
    if (submittedStatus) {
      if (submittedStatus === "Sitesurvey Completed") {
        setShowCompleteModal(true)
      } else if (submittedStatus === "Sitesurvey Pending") {
        setShowPendingModal(true);
      } else if (submittedStatus === "Sitesurvey Started") {
        setShowStartModal(true);
      } else if (submittedStatus === "Sitesurvey Cancelled") {
        setShowCancelModal(true)
      }
    }
  }, [submittedStatus])

  useEffect(() => {
    if (SiteSurveyDetails?.customerAddresses) {
      setAddresses(JSON?.parse(SiteSurveyDetails?.customerAddresses)?.[0])
      setSiteSurveyItems(JSON?.parse(SiteSurveyDetails?.SiteSurveyItems))
      setCustomerProfile(JSON?.parse(SiteSurveyDetails?.CustomerProfile)?.[0])
    }
  }, [SiteSurveyDetails])

  const handleExtendClose = () => {
    setIsExtend(false);
  }

  const handleExtendSubmit = async (data, resetForm) => {
    try {
      const response = await axiosInstance.post('', {
        "sp": "usp_InsertSitesurveyExtensionHistory",
        "siteSurveyId": id,
        "requestedBy": userId,
        ...data
      })
      if (response) {
        fetchSiteSurveyDetails()
        handleExtendClose()
        resetForm();
        if (user?.userRole === "Super Admin" || user?.userRole === "Supervisor") {
          showSuccess("Successfully Extended")
        } else {
          showSuccess("Extension request sent successfully")
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleCancellation = async () => {
    try {
      const response = await axiosInstance.post('', {
        "sp": "usp_InsertSiteSurveyCancellationHistory",
        "siteSurveyId": id,
        "requestedBy": userId
      });

      if (response) {
        fetchSiteSurveyDetails();
        setShowCancelModal(false);
        setSubmittedStatus("'");
        setSelectedStatus("");
        if (user?.userRole === "Super Admin" || user?.userRole === "Supervisor") {
          showSuccess("Successfully Cancelled")
        } else {
          showSuccess("Cancellation request sent successfully")
        }
      }
    } catch (error) {
      setShowCancelModal(false);
      setSubmittedStatus("'");
      setSelectedStatus("");
    }
  }

  const handleStartConfirmation = async () => {
    try {
      const response = await axiosInstance.post('',
        {
          "sp": "usp_InsertSiteSurveyStatus",
          "sitesurveyId": id,
          "changedBy": userId,
          "SiteSurveyNewStatus": "Sitesurvey Started",
          "reason": ""
        });

      if (response) {
        fetchSiteSurveyDetails();
        setShowStartModal(false);
        fetchStatusList();
        showSuccess("Successfully started")
        setSubmittedStatus("");
        setSelectedStatus("");
      }
    } catch (error) {
      console.log(error);
      setSubmittedStatus("");
      setShowStartModal(false);
    }

  }

  const handlePendingConfirmationConfirmation = async () => {
    try {
      const response = await axiosInstance.post('',
        {
          "sp": "usp_InsertSiteSurveyStatus",
          "sitesurveyId": id,
          "changedBy": userId,
          "SiteSurveyNewStatus": "SiteSurvey Pending",
          "reason": reason,
        });

      if (response) {
        fetchSiteSurveyDetails();
        showSuccess("Successfully marked as pending")
        setShowPendingConfirmationModal(false);
        fetchStatusList();
        setSubmittedStatus("");
        setSelectedStatus("");
        setReason("")
      }
    } catch (error) {
      console.log(error);
      setSubmittedStatus("");
      setReason("");
      setShowPendingConfirmationModal(false);
    }
  }

  const handlePendingSubmit = async (values, { resetForm }) => {
    setReason(values?.reason);
    setShowPendingConfirmationModal(true);
    setShowPendingModal(false);
  }

  const validationSchema2 = Yup.object().shape({
    reason: Yup.string()
      .trim()
      .required("Reason is required")
  });

  const handleMarkAsCompleted = async () => {
    try {
      const response = await axiosInstance.post('', {
        "sp": "usp_SiteSurveyMarkAsCompleted",
        "SiteSurveyId": id
      })
      if (response) {
        fetchSiteSurveyDetails();
        setShowCompleteModal(false);
        showSuccess("Marked As Completed");
      }
    } catch (error) {
      setShowCompleteModal(false);
    }
  }

  const handleCancelConfirmation = async () => {
    handleCancellation()
  };

  useEffect(() => {
    if (SiteSurveyDetails?.SiteSurveyLocationImages) {
      setImages(JSON.parse(SiteSurveyDetails?.SiteSurveyLocationImages)?.map(item => ({ imagePath: item?.imagePath, imageEvent: item?.imageEvent })))
      setImagePreviews(JSON?.parse(SiteSurveyDetails?.SiteSurveyLocationImages)?.map(item => (`${process.env.REACT_APP_BASE_URL}` + item?.imagePath)));
    }
  }, [SiteSurveyDetails?.SiteSurveyLocationImages])

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    // Replace the body content with the content to print
    document.body.innerHTML = printContents;

    // Trigger the print
    window.print();

    // Restore the original content
    document.body.innerHTML = originalContents;
    window.location.reload(); // Refresh to restore React state
  };

  return (
    <>
      <Modal isOpen={showCancelModal} toggle={() => { setShowCancelModal(false); setSubmittedStatus(""); }} backdrop="static">
        <ModalHeader toggle={() => { setShowCancelModal(false); setSubmittedStatus(""); }}>Confirm Cancellation</ModalHeader>
        <ModalBody>Are you sure you want to cancel this work order?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowCancelModal(false); setSubmittedStatus(""); }}>No</Button>
          <Button color="danger" onClick={handleCancelConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      {/* Mark as Complete Confirmation Modal */}
      <Modal isOpen={showCompleteModal} toggle={() => { setShowCompleteModal(false); setSubmittedStatus("") }} backdrop="static">
        <ModalHeader toggle={() => { setShowCompleteModal(false); setSubmittedStatus("") }}>Confirm Completion</ModalHeader>
        <ModalBody>Are you sure you want to mark this Site Survey as completed?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowCompleteModal(false); setSubmittedStatus("") }}>No</Button>
          <Button color="primary" onClick={() => handleMarkAsCompleted()}>Yes</Button>
        </ModalFooter>
      </Modal>


      <Modal isOpen={showStartModal} toggle={() => { setShowStartModal(false); setSubmittedStatus(""); }} backdrop="static">
        <ModalHeader toggle={() => { setShowStartModal(false); setSubmittedStatus(""); }}>Confirm Startlation</ModalHeader>
        <ModalBody>Are you sure you want to Start this work order?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowStartModal(false); setSubmittedStatus(""); }}>No</Button>
          <Button color="danger" onClick={handleStartConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showPendingConfirmationModal} toggle={() => { setShowPendingConfirmationModal(false); setSubmittedStatus("") }} backdrop="static">
        <ModalHeader toggle={() => { setShowPendingConfirmationModal(false); setSubmittedStatus("") }}>Confirm Pending</ModalHeader>
        <ModalBody>Are you sure you want to mark as Pending?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { setShowPendingConfirmationModal(false); setSubmittedStatus(""); }}>No</Button>
          <Button color="danger" onClick={handlePendingConfirmationConfirmation}>Yes</Button>
        </ModalFooter>
      </Modal>

      {/* modal for pending submit */}
      <Modal isOpen={showPendingModal} toggle={() => { setShowPendingModal(false); setSubmittedStatus(""); setReason("") }} centered backdrop="static">
        <ModalHeader toggle={() => { setShowPendingModal(false); setSubmittedStatus(""); setReason("") }}>Provide a Reason</ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-center align-items-center">
            <Formik
              initialValues={{ reason: "" }}
              validationSchema={validationSchema2}
              onSubmit={handlePendingSubmit}
            >
              {({ errors, touched }) => (
                <FormikForm
                  className="px-4 mx-3 bg-white"
                  style={{ minWidth: "300px", width: "600px", maxWidth: "500px" }}
                >
                  {/* Reason Input Field */}
                  <FormGroup>
                    <Label for="reason">Reason</Label>
                    <Field
                      as={Input}
                      type="textarea"
                      id="reason"
                      name="reason"
                      placeholder="Enter your reason..."
                      rows="4"
                      className={touched.reason && errors.reason ? "is-invalid" : ""}
                    />
                    <ErrorMessage name="reason" component="div" className="text-danger" />
                  </FormGroup>

                  {/* Submit and Cancel Buttons */}
                  <div className='d-flex justify-content-end gap-3'>
                    <Button color="secondary" onClick={() => { setShowPendingModal(false); setSubmittedStatus(""); setReason("") }}>
                      Cancel
                    </Button>
                    <Button color="primary" type='submit'>
                      Submit
                    </Button>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>


      <InsertExtensionModal endDate={isExtend ? SiteSurveyDetails?.scheduledEndDateTime : ''} visible={isExtend} handleClose={handleExtendClose} onExtendSubmit={handleExtendSubmit} />
      <div className="page-content px-4">
        <div className="d-flex justify-content-between align-items-center mx-2">
          <Breadcrumb title="Site Survey Details" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Site Survey Details", link: '#' }]} />
          <Button className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center' onClick={() => navigate('/SiteSurveys', { state: { cameFromSiteSurvey: true } })}>
            Back
          </Button>
        </div>
        {!loading && <div>
          <Row className='gap-2'>
            {/* Buttons */}
            <Col sm="12" md="12" lg="12" className="text-end mb-4">
              {statusList?.length > 0 && <div className='d-inline-block me-2'>
                <div className='d-flex gap-2 align-items-center'>
                  <Select
                    options={statusList?.map(item => ({ label: item?.stateName, value: item?.stateName }))}
                    value={selectedStatus}
                    onChange={setSelectedStatus}
                    placeholder="Select Status"
                    isClearable={true}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        textAlign: "left",
                        width: "233px",  // Set fixed width
                        paddingLeft: "0px",  // Adjust left padding
                        paddingRight: "0px", // Adjust right padding
                      }),
                      input: (provided) => ({
                        ...provided,
                        width: "200px",  // Set width for input
                        paddingLeft: "0px !important",  // Ensure content starts from the left
                        paddingRight: "0px !important",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        paddingLeft: "0px",  // Ensure selected value is properly aligned
                        paddingRight: "0px",
                      }),
                      menu: (provided) => ({
                        ...provided,
                        textAlign: "left",  // Aligns dropdown items to the left
                      }),
                      menuList: (provided) => ({
                        ...provided,
                        textAlign: "left",  // Ensures each item inside the dropdown is aligned left
                      }),
                    }} />
                  <Button onClick={() => { setSubmittedStatus(selectedStatus?.value) }}>submit</Button>
                </div>
              </div>}
              {<Button color="primary" className="me-2" title="take print" onClick={handlePrint}>Print</Button>}
              {((SiteSurveyDetails?.isEditbtnVisib === 1) && permissions2?.map(item => item?.permissionName)?.includes("Edit SiteSurvey")) && <Button color="primary" className="me-2" onClick={() => navigate(`/editSiteSurvey/${id}`)}>Edit</Button>}
              {((SiteSurveyDetails?.isExtendbtnVisib === 1) && permissions2?.map(item => item?.permissionName)?.includes("Site Survey Extension")) && <Button color="secondary" className="me-2" onClick={() => setIsExtend(true)}>Extent</Button>}

            </Col>
          </Row>

          <Row>
            {/* Site Survey Number & Status */}
            <Col xs="6" md="6" lg="6">
              <h4>#{SiteSurveyDetails?.siteSurveyNumber}</h4>
            </Col>
            <Col xs="6" md="6" lg="6" className="text-end">
              <h6 className='text-end p-1 px-3 d-inline rounded-pill bg-secondary' style={{ border: "1px solid lightgray" }}>{SiteSurveyDetails?.SiteSurveyStatus
                ?.replace(/sitesurvey /i, "site survey ")
                .replace(/\b\w/g, (char) => char.toUpperCase())}</h6>
            </Col>
          </Row>

          <Row>
            <Col sm="12" >
              <Card className="mb-4" >
                <CardBody >
                  <Row>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Start Date:</h6>
                            <p className='m-0'>{formatDateTimeToAmPm(SiteSurveyDetails?.scheduledStartDateTime)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>End Date:</h6>
                            <p className='m-0'>{formatDateTimeToAmPm(SiteSurveyDetails?.scheduledEndDateTime)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <RiTeamLine size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Team:</h6>
                            <p className='m-0'>{SiteSurveyDetails?.teamName}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaUserCircle size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Comment:</h6>
                            <p className='m-0'>{SiteSurveyDetails?.agentComments || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          < FaUser size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }} >Employee Name</h6>
                            <p className='m-0'>{SiteSurveyDetails?.userName}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaCodeBranch size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Branch</h6>
                            <p className='m-0'>{SiteSurveyDetails?.branchName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaHashtag size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Empoyeee Id</h6>
                            <p className='m-0'>{SiteSurveyDetails?.employeeId}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Created At:</h6>
                            <p className='m-0'>{formatDateTimeToAmPm(SiteSurveyDetails?.createdAt)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    {SiteSurveyDetails?.sabelUserId && <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <LuSquareUserRound  size={28} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>SebelUserId:</h6>
                            <p className='m-0'>{SiteSurveyDetails?.SabelUserIdName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>}
                    {SiteSurveyDetails?.solutionName && <Col xs={6} md={3}>
                      <div className='d-flex align-items-start gap-2 my-3' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <AiOutlineSolution  size={28} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-1'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Solution:</h6>
                            <p className='m-0'>{SiteSurveyDetails?.solutionName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>}
                  </Row>
                  {/* <ListGroupItem><strong>Created At:</strong> {createdAt}</ListGroupItem> */}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            {/* Customer Information & Address Information */}
            <Col sm="12" md="6" lg="6">
              <Card className="mb-4">
                <CardBody>
                  <div className='d-flex justify-content-between align-items-center' >
                    <h5 className='fw-bold'>Customer Information</h5>
                  </div>
                  <div className='pt-2 mt-3'>
                    <p>{customerProfile?.customerNameEng} ({customerProfile?.customerNameAr})</p>
                    <p><strong>Contact:</strong> {customerProfile?.contactNumber1} , {customerProfile?.contactNumber2}</p>
                    <p><strong>Contract Number:</strong> {customerProfile?.contractNumber}</p>
                    <p><strong>ContractId:</strong> {customerProfile?.contractId}</p>
                    <p><strong>Subscriber Number:</strong> {customerProfile?.subscriberNumber}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col sm="12" md="6" lg="6" >
              <Card className="mb-4">
                <CardBody style={{ minHeight: "297px" }}>
                  <h5>Address Information</h5>
                  <div className='pt-2 mt-3'>
                    <p> {addresses?.addressLine}</p>
                    <p> {addresses?.area}</p>
                    <p> {addresses?.areaDescription}</p>
                    <p> {addresses?.landMark}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* Site Survey Items Table */}
          {SiteSurveyItems && <Row>
            <Col sm="12" md="12" lg="12">
              <Card className="mb-4" >
                <CardBody >
                  <h5>Site Survey Items</h5>
                  <Table >
                    <thead>
                      <tr>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Image</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Item</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Department</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {SiteSurveyItems?.map((item, index) => (
                        <tr key={index}>
                          <td className='border-1'>{<img src={`${process.env.REACT_APP_BASE_URL}${item?.image}`} style={{ objectFit: "cover", width: "50px", height: "50px", borderRadius: "25px" }} />}</td>
                          <td className='border-1'><span>{item.catalogueItem}</span><br /><span>{`(${item?.model}, ${item?.sku})`}</span></td>
                          <td className="border-1">{item?.departmentName}</td>
                          <td className='border-1'>{item.quantity}</td>
                        </tr>
                      ))}
                      {SiteSurveyItems?.length <= 0 && <tr>
                        <td colSpan='3' className='text-center'>No Items found</td>
                      </tr>}
                    </tbody>
                  </Table>
                  <h5 className='text-end'><strong>Total Time:</strong>1hr</h5>
                </CardBody>
              </Card>
            </Col>
          </Row>}

          {imagePreviews?.length > 0 && <div >
            <h5>Location Images</h5>
            <Row>
              {imagePreviews.map((preview, index) => (
                <Col key={index} xs="12" md="4" className="mb-3 position-relative">
                  <div
                    className="image-preview-container"
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      width: '100%',
                      height: 'auto',
                    }}
                  >
                    <img
                      src={preview}
                      alt={`preview-${index}`}
                      style={{
                        width: '100%',
                        height: '200px',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        objectFit: "contain"
                      }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </div>}
        </div>}
        <div style={{ display: "none" }} ref={printRef}>
          <div className='d-flex justify-content-center align-items-center'><img src={LOGO_IMG} /></div>
          <h5>SiteSurvey FORM :#{SiteSurveyDetails?.SiteSurveyNumber}</h5>
          <Row>
            <Col sm="12" >
              <Card className="mb-4" >
                <CardBody >
                  <Row>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Start Date:</h6>
                            <p className='ms-1'>{formatDateTimeToAmPm(SiteSurveyDetails?.scheduledStartDateTime)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>End Date:</h6>
                            <p className='ms-1'>{formatDateTimeToAmPm(SiteSurveyDetails?.scheduledEndDateTime)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <RiTeamLine size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Team:</h6>
                            <p className='ms-1'>{SiteSurveyDetails?.teamName}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaUserCircle size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}> Comment:</h6>
                            <p className='ms-1'>{SiteSurveyDetails?.agentComments || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          < FaUser size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }} >Employee Name</h6>
                            <p className='ms-1'>{SiteSurveyDetails?.userName}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaCodeBranch size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Branch</h6>
                            <p className='ms-1'>{SiteSurveyDetails?.branchName || 'N/A'}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <FaHashtag size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Empoyeee Id</h6>
                            <p className='ms-1'>{SiteSurveyDetails?.employeeId}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={6} md={3}>
                      <div className='d-flex align-items-center gap-2' >
                        <div className='p-3' style={{ backgroundColor: "lightgray", borderRadius: "50%" }}>
                          <SlCalender size={25} />
                        </div>
                        <div className='d-flex  justify-content-center align-items-center' >
                          <div className='mt-3'>
                            <h6 className='text-black' style={{ fontWeight: "bold" }}>Created At:</h6>
                            <p className='ms-1'>{formatDateTimeToAmPm(SiteSurveyDetails?.createdAt)}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/* <ListGroupItem><strong>Created At:</strong> {createdAt}</ListGroupItem> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {/* Customer Information & Address Information */}
            <Col xs="6" md="6" lg="6">
              <Card className="mb-2">
                <CardBody>
                  <div className='d-flex justify-content-between align-items-center' >
                    <h5 className='fw-bold'>Customer Information</h5>
                  </div>
                  <div className='pt-2 mt-3'>
                    <p>{customerProfile?.customerNameEng} ({customerProfile?.customerNameAr})</p>
                    <p><strong>Contact:</strong> {customerProfile?.contactNumber1} , {customerProfile?.contactNumber2}</p>
                    <p><strong>Contract Number:</strong> {customerProfile?.contractNumber}</p>
                    <p><strong>ContractId:</strong> {customerProfile?.contractId}</p>
                    <p><strong>Subscriber Number:</strong> {customerProfile?.subscriberNumber}</p>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xs="6" md="6" lg="6" >
              <Card className="mb-2">
                <CardBody style={{ minHeight: "297px" }}>
                  <h5>Address Information</h5>
                  <div className='pt-2 mt-3'>
                    <p> {addresses?.addressLine}</p>
                    <p> {addresses?.area}</p>
                    <p> {addresses?.areaDescription}</p>
                    <p> {addresses?.landMark}</p>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col sm="12" md="12" lg="12">
              <Card className="mb-2" >
                <CardBody >
                  <h5>Site Survey Items</h5>
                  <Table >
                    <thead>
                      <tr >
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Item</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Department</th>
                        <th className='text-white border-1' style={{ backgroundColor: "#04A1B6" }}>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {SiteSurveyItems?.map((item, index) => (
                        <tr key={index}>
                          <td className='border-1'><span>{item.catalogueItem}</span><br /><span>{`(${item?.model}, ${item?.sku})`}</span></td>
                          <td className='border-1'>{item.departmentName}</td>
                          <td className='border-1'>{item.quantity}</td>
                        </tr>
                      ))}
                      {SiteSurveyItems?.length <= 0 && <tr>
                        <td colSpan='3' className='text-center'>No Items found</td>
                      </tr>}
                    </tbody>
                  </Table>

                </CardBody>
              </Card>
            </Col>
          </Row>
          <div className='terms-and-conditions-print'>
            <h5>Terms And Conditions</h5>
            <ul>
              <li>This package does not include the Cat 6 Ethernet cable / Piping required to connect the cameras to the NVR, nor does it include the hard drive needed to store recorded footage. Hard drive costs vary based on capacity (typically ranging from 20 K.D. to 90 K.D.). These components must be purchased separately according to the customer’s needs.</li>
              <li>This package does not include any additional accessories that are not essential for the basic operation of the camera and NVR system, such as an LCD screen. These optional items may be purchased separately, at the customer’s discretion and expense.</li>
            </ul>
          </div>
          <div className='d-flex justify-content-between align-items-center' style={{ minHeight: "120px" }}>
            <div className='' style={{ borderTop: "1px solid lightgray" }}>
              <h6 style={{ marginTop: "60px" }}>Customer Sign</h6>
            </div>
            <div className="" style={{ borderTop: "1px solid lightgray" }}>
              <h6 style={{ marginTop: "60px" }}>Sales Agent Sign</h6>
            </div>
          </div>
        </div>
        {loading && <div className='d-flex justify-content-center align-items-center' style={{ minHeight: "400px" }}>
          <FadeLoader color="#007bff" size={35} />
        </div>}
      </div>
    </>

  );
};

export default SiteSurveyDetails;
